import TableWidget from "csi/table/Widget";
import { QueryLevel } from "csi/view/_query/Level";
import xml from "csi/xml";
import Query from "csi/xml/Query";
import declare from "dojo/_base/declare";

const UpdateSupplierRequestTableController = declare(TableWidget, {

	/** List of product source to augment the main query - set from ColorwayAllocationManageStore */
	productSources: null,

	/**
     * @override
     * Augment the main query to filter by product source
     */
	onCreateMainQueryLevel(ql: QueryLevel): void {
		const { productSources } = this;

		if (productSources?.length) {
			const q = new Query();
			const qOr = q.Or();
			productSources.forEach((ps) => {
				const isFDD = xml.isValidURL(ps.SupplierFactory); 
				const SupplierRequestSourceAttribute = isFDD ? "SRSupplierFactories" : "SRSuppliers";
				qOr.RefAttr(SupplierRequestSourceAttribute, xml.OP_EQUALS, isFDD ? ps.SupplierFactory : ps.Supplier);
			});

			if (!q.isEmpty()) {
				ql.serverQuery = q;
			}
		}
	},
});

export = UpdateSupplierRequestTableController;